import React, { useState, useEffect } from "react";

import { Row, Col, Card, CardBody, Button } from "reactstrap";

// components
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from "@fullcalendar/interaction";
import listPlugin from '@fullcalendar/list';

// helpers
import { formateDateandTimeApi } from "helpers/formats";

// services
import { showMessage } from "../../../services/message.js";
import { api_GET } from "../../../services/api_service.js";
import ConfirmacaoVistoria from "./ConfirmacaoVistoria";

//Context
import { useAuth } from "../../../context/auth";

export default function CalendarioVistoria({ handleReturn }) {
    const { setLoading } = useAuth();

    const [eventosCalendario, set_eventosCalendario] = useState([]);

    const loadEventosCalendario = () => {
        setLoading(true);
        api_GET(`AgendamentoVistoria/GetFromCalendario`)
            .then(result => {
                let _eventos = [];
                result.data.map(m => {
                    _eventos.push({
                        requerimentoTransportadorAgendamento_Id: m.requerimentoTransportadorAgendamento_Id,
                        placa: m.placa,
                        id: m.requerimentoTransportadorAgendamento_Id,
                        start: formateDateandTimeApi(m.dataHora),
                        title: m.placa,
                        backgroundColor: "#6bd098",
                        allDay: false
                    })
                })
                set_eventosCalendario(_eventos);
            })
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false));
    }

    useEffect(() => {
        loadEventosCalendario();
    }, []);

    const [evento, set_evento] = useState(null);
    const handleEventClick = (e) => {
        set_evento(eventosCalendario.filter(f => f.requerimentoTransportadorAgendamento_Id == e.event.id)[0]);
    }

    const handleReturnConfirmacaoVistoria = (reload) => {
        set_evento(null);
        if (reload)
            loadEventosCalendario();
    }

    return (
        <>
            <div className="content">
                <Row>
                    <Col md="12">
                        <Button type="button" color="Primary" onClick={handleReturn}><i className="fas fa-chevron-left"></i>  Voltar</Button>
                        <Card className="border-success mb-2 ">
                            <CardBody>
                                <Row>
                                    <Col md="12">
                                        <FullCalendar
                                            plugins={[dayGridPlugin, interactionPlugin, listPlugin]}
                                            initialView="dayGridMonth"
                                            locale="pt-br"
                                            selectable="true"
                                            headerToolbar={{
                                                left: 'title',
                                                center: '',
                                                right: 'prev,next'
                                            }}
                                            eventClick={handleEventClick}
                                            events={eventosCalendario}
                                        />
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
            {evento != null &&
                <ConfirmacaoVistoria
                    requerimentoTransportadorAgendamento_Id={evento.requerimentoTransportadorAgendamento_Id}
                    placa={evento.placa}
                    handleReturn={handleReturnConfirmacaoVistoria}
                >
                </ConfirmacaoVistoria>
            }
        </>
    );
};

